import React from 'react';

export const OFFER_TABLE_STYLE = {
  tableLayout: 'fixed',
  width: '100%',
};

export const OFFER_TH_STYLE = {
  wordBreak: 'keep-all',
  overflowWrap: 'normal',
  hyphens: 'none',
  lineHeight: 1.25,
  verticalAlign: 'middle',
  textAlign: 'center',
  paddingLeft: '4px',
  paddingRight: '4px',
};

export const OFFER_COL = {
  check: { width: '3.5%' },
  statusImprovement: { width: '6%' },
  idOffer: { width: '9%' },
  status: { width: '8%' },
  deliveryBasis: { width: '5%' },
  incoterm: { width: '6.5%' },
  ot: { width: '5%' },
  loadingPort: { width: '8.5%' },
  port: { width: '8.5%' },
  alpha: { width: '5%' },
  hps: { width: '5%' },
  matching: { width: '5.5%' },
  action: { width: '5%' },
  parcelSize: { width: '5%' },
  cargoRatio: { width: '7%' },
};

export const ThLabel = ({ title, lines }) => (
  <span
    className='d-inline-block w-100'
    title={title || lines.filter(Boolean).join(' ')}
    style={{ textAlign: 'center' }}
  >
    {lines.map((line, index) => (
      <React.Fragment key={`${line}-${index}`}>
        {index > 0 ? <br /> : null}
        {line}
      </React.Fragment>
    ))}
  </span>
);

export const OFFER_HEADER = {
  improvement: { title: 'Status Improvement', lines: ['Improvement'] },
  idOffer: { title: 'ID Offer', lines: ['ID Offer'] },
  deliveryBasis: { title: 'Delivery Basis', lines: ['Delivery', 'Basis'] },
  incoterm: { title: 'Incoterm - Route', lines: ['Incoterm', 'Route'] },
  ot: { title: 'Operational Tolerance', lines: ['Op.', 'Tolerance'] },
  loadingPort: { title: 'Loading Port', lines: ['Loading', 'Port'] },
  port1: { title: 'Port 1', lines: ['Port 1'] },
  port2: { title: 'Port 2', lines: ['Port 2'] },
  port3: { title: 'Port 3', lines: ['Port 3'] },
  alphaDyed: { title: 'Alpha Dyed', lines: ['Alpha', 'Dyed'] },
  alphaUndyed: { title: 'Alpha Undyed', lines: ['Alpha', 'Undyed'] },
  hpsAlpha: { title: 'HPS Alpha', lines: ['HPS', 'Alpha'] },
  matchingHps: { title: 'Matching HPS', lines: ['Matching', 'HPS'] },
  cargoRatio: { title: 'Cargo Ratio', lines: ['Cargo', 'Ratio'] },
  parcelSize: { title: 'Parcel Size', lines: ['Parcel', 'Size'] },
  alphaMt: { title: 'Alpha (USD/MT)', lines: ['Alpha', 'USD/MT'] },
  alphaDyedImp: {
    title: 'Alpha Dyed (Improvement)',
    lines: ['Dyed', 'Imp.'],
  },
  alphaUndyedImp: {
    title: 'Alpha Undyed (Improvement)',
    lines: ['Undyed', 'Imp.'],
  },
  alphaImp: { title: 'Alpha (Improvement)', lines: ['Alpha', 'Imp.'] },
  action: { title: 'Action', lines: ['Action'] },
};

export const thStyle = col => ({ ...OFFER_COL[col], ...OFFER_TH_STYLE });
